<template>
    <div class="automation-wizard-form">
        <div class="automation-wizard-form__step">
            <CompassAlert
                v-if="currentStep.information"
                type="neutral"
                :description="currentStep.information"
                :showClose="false"
                class="automation-wizard-form__information"
            />
            <div class="automation-wizard-form__field-group">
                <AutomationWizardFormField
                    v-for="field in visibleFields"
                    :key="field.id"
                    :field="field"
                    :modelValue="getFieldValue(field.id)"
                    :formData="formData"
                    @update:model-value="updateFieldValue(field.id, $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AutomationWizardFormField from 'vcomponents/automation/templates/Wizard/Form/AutomationWizardFormField.vue';

export default {
    components: {
        AutomationWizardFormField,
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        currentStep: {
            type: Object,
            required: true,
        },
    },
    emits: ['update:modelValue', 'field-change'],
    computed: {
        formData: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        visibleFields() {
            return (this.currentStep.fields || []).filter((field) => field.type !== 'hidden');
        },
    },
    methods: {
        getFieldValue(fieldName) {
            const field = this.currentStep.fields.find(field => field.id === fieldName);
            
            if (field?.props?.mappedFields) {
                const reconstructedObject = {};
                for (const [key, targetFieldId] of Object.entries(field.props.mappedFields)) {
                    reconstructedObject[key] = this.formData[targetFieldId];
                }
                return reconstructedObject;
            }
            
            return this.formData[fieldName];
        },
        updateFieldValue(fieldName, value) {
            const field = this.currentStep.fields.find(field => field.id === fieldName);
            
            if (field?.props?.mappedFields && typeof value === 'object') {
                for (const [key, targetFieldId] of Object.entries(field.props.mappedFields)) {
                    if (value[key] !== undefined) {
                        this.formData[targetFieldId] = value[key];
                        this.$emit('field-change', targetFieldId);
                    }
                }
            } else {
                this.formData[fieldName] = value;
                this.$emit('field-change', fieldName);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-form {
    &__information {
        margin: 0 0 var(--spacing-3);
    }
    &__field-group {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-3);
    }
}
</style>
